// extracted by mini-css-extract-plugin
export default {"function":"functionBounds_function__bCIka","functionBody":"functionBounds_functionBody__99xx2","text":"functionBounds_text__k+zRu"};